import type {ColumnsSetting} from '../types/Api';
import type {EagColumnState} from '../types/EagColumnState';
import {toIntegerWidth} from './toIntegerWidth';

export const getPresetStates = (columnStates: EagColumnState[]): ColumnsSetting[] =>
  columnStates.map((cs) => ({
    columnKey: cs.key,
    visible: !cs.hidden,
    width: toIntegerWidth(cs.width),
    pinned: cs.pinned ?? null,
  }));
